import {
  defaultFont,
  container,
  containerFluid,
  primaryColor,
  whiteColor,
} from "assets/jss/material-dashboard-pro-react.js";

/**
 * Estilos del footer custom.
 *
 * Objetivos de esta versión:
 * - eliminar el footer fijo que tapaba contenido
 * - eliminar márgenes rígidos dependientes del sidebar
 * - apilar texto + logos en móvil
 * - mantener una presentación limpia y estable en desktop
 */
const customStyleFooter = {
  /**
   * Footer en flujo normal del documento.
   *
   * Importante:
   * - Ya NO es fixed.
   * - Así deja de tapar formularios, tablas y CTAs en móvil.
   */
  footer: {
    ...defaultFont,
    position: "relative",
    width: "100%",
    backgroundColor: "#f9f9f9",
    borderTop: "1px solid rgba(0, 0, 0, 0.08)",
    marginTop: "24px",
    paddingTop: "12px",
    paddingBottom: "12px",
    overflowX: "hidden",
  },

  /**
   * Variante container normal por compatibilidad.
   * Aunque normalmente usas fluid, dejamos ambas definidas.
   */
  container: {
    ...container,
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    rowGap: "12px",
    textAlign: "center",
  },

  /**
   * Contenedor fluido principal del footer.
   *
   * Desktop:
   * - layout vertical limpio
   * - centrado
   *
   * Móvil:
   * - mismo patrón, con menos padding y separación controlada
   */
  containerFluid: {
    ...containerFluid,
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    rowGap: "12px",
    textAlign: "center",
    paddingLeft: "16px",
    paddingRight: "16px",

    "@media (max-width: 960px)": {
      rowGap: "10px",
      paddingLeft: "12px",
      paddingRight: "12px",
    },
  },

  /**
   * Bloque de texto institucional/disclaimer.
   *
   * Cambios clave:
   * - sin margin-left duro
   * - ancho fluido
   * - lectura centrada en móvil
   * - wrap correcto
   */
  textFoot: {
    width: "100%",
    maxWidth: "1100px",
    margin: "0 auto",
    fontSize: "12px",
    lineHeight: "1.6",
    color: "rgba(0, 0, 0, 0.72)",
    textAlign: "center",
    wordBreak: "break-word",

    "& a": {
      color: primaryColor[0],
      textDecoration: "none",
    },

    "@media (max-width: 960px)": {
      fontSize: "11px",
      lineHeight: "1.55",
      maxWidth: "100%",
    },
  },

  /**
   * Contenedor del bloque de logos.
   *
   * Cambios clave:
   * - sin margin-left del 30%
   * - centrado real con flex
   * - ancho fluido
   */
  logoFoot: {
    width: "100%",
    margin: "0 auto",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },

  /**
   * Wrapper izquierdo de la banda de logos.
   * La imagen se adapta al ancho disponible sin romper.
   */
  left: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",

    "& img": {
      display: "block",
      width: "100%",
      maxWidth: "760px",
      height: "auto",
      objectFit: "contain",
    },

    "@media (max-width: 960px)": {
      "& img": {
        maxWidth: "100%",
      },
    },
  },

  /**
   * Se mantiene por compatibilidad aunque ahora no se use.
   */
  right: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    "& img": {
      maxHeight: "60px",
      width: "auto",
      maxWidth: "100%",
    },
  },

  /**
   * Enlaces auxiliares del footer.
   */
  a: {
    color: primaryColor[0],
    textDecoration: "none",
    backgroundColor: "transparent",
  },

  /**
   * Helpers heredados/compatibilidad.
   */
  list: {
    marginBottom: "0",
    padding: "0",
    marginTop: "0",
  },

  inlineBlock: {
    display: "inline-block",
    padding: "0",
    width: "auto",
  },

  whiteColor: {
    "&,&:hover,&:focus": {
      color: whiteColor,
    },
  },
};

export default customStyleFooter;